import {Application} from "../../lib/Application.js";
import {TimesheetEntryRepository} from "../TimesheetEntryRepository.js";
import {SettingsRepository} from "../../app/SettingsRepository.js";
import {ClickUpTimesheetEntryRepository} from "../clickup/ClickUpTimesheetEntryRepository.js";
import {CustomerRepository} from "../../crm/CustomerRepository.js";
import {ClickUpClient} from "../../lib/ClickUp/ClickUpClient.js";

/** @param {Application} app **/
export function initTimesheet(app) {

    app.bind(TimesheetEntryRepository, () => {

        let settingsRepo = app.resolve(SettingsRepository);
        let settings = settingsRepo.get();
        let customerRepo = app.resolve(CustomerRepository);

        let workspaceIdProvider = async () => {
            let workspaceIds = [settings.defaultWorkSpaceId];
            let customers = await customerRepo.all();

            for (let customer of customers) {
                if (customer.workspaceId && customer.workspaceId !== settings.defaultWorkSpaceId) {
                    workspaceIds.push(customer.workspaceId);
                }
            }
            return workspaceIds;
        }

        return new ClickUpTimesheetEntryRepository(
            app.resolve(ClickUpClient),
            customerRepo,
            workspaceIdProvider(),
            settings.customerSource
        );
    });
}